import { SafeAreaView, StyleSheet, ScrollView, RefreshControl, View, KeyboardAvoidingView, Dimensions, Platform } from 'react-native';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { showMessage } from "react-native-flash-message";
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomDropDownWithIcons from '../../../components/CustomDropDownWithIcons/CustomDropDownWithIcons';
import CustomButton from '../../../components/CustomButton';
import CustomText from '../../../components/CustomText/CustomText';
import CustomPhoneNumber from '../../../components/CustomPhoneNumber';

import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useAccount } from '../../../hooks/useAccount';
import { useTheme } from '@react-navigation/native';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import KeyboardAwareContainer from '../../../components/Platform/KeyboardAwareContainer';
import FlashMessage from 'react-native-flash-message';

// * Language 
import { useTranslation } from 'react-i18next';

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var width = Dimensions.get('window').width; //full width

const MyAccountEmergencyInformationScreen = ({ navigation }) => {

    const { t } = useTranslation();
    const insets = useSafeAreaInsets();

    // TODO: This is not defined in the Database hardcoding for now for Relationship 
    const relationshipOptions = [
        { label: t('common:spouse'), value: 'Spouse' },
        { label: t('common:father'), value: 'Father' },
        { label: t('common:mother'), value: 'Mother' },
        { label: t('common:child'), value: 'Child' },
        { label: t('common:other'), value: 'Other' },
    ];

    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { account } = useAccountContext();
    const { accountGet, accountEdit, emergencyInformationGet, emergencyInformationEdit, isLoading, error } = useAccount();

    // refs
    // emergency contact info
    const relationshipRef = useRef(null);
    const nameRef = useRef(null);
    const addressRef = useRef(null);
    const emergencyTelephoneInputRef = useRef(null);
    const emergencyTelephoneStoredRef = useRef(null);
    const emergencyMobileInputRef = useRef(null);
    const emergencyMobileStoredRef = useRef(null);
    // doctor info
    const drNameRef = useRef(null);
    const drAddressRef = useRef(null);
    const drTelephoneInputRef = useRef(null);
    const drTelephoneStoredRef = useRef(null);
    const drMobileInputRef = useRef(null);
    const drMobileStoredRef = useRef(null);

    const submitClickedRef = useRef(null);

    // state variables
    const [submitClicked, setSubmitClicked] = useState(false);
    // emergency info
    const [relationship, setRelationship] = useState("");
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [emergencyTelephoneStored, setEmergencyTelephoneStored] = useState("");
    const [emergencyTelephoneDefaultCode, setEmergencyTelephoneDefaultCode] = useState(undefined);
    const [emergencyTelephoneFormatted, setEmergencyTelephoneFormatted] = useState("");
    const [emergencyMobileStored, setEmergencyMobileStored] = useState("");
    const [emergencyMobileDefaultCode, setEmergencyMobileDefaultCode] = useState(undefined);
    const [emergencyMobileFormatted, setEmergencyMobileFormatted] = useState("");
    // doctor info
    const [drName, setDrName] = useState("");
    const [drAddress, setDrAddress] = useState("");
    const [drTelephoneStored, setDrTelephoneStored] = useState("");
    const [drTelephoneDefaultCode, setDrTelephoneDefaultCode] = useState(undefined);
    const [drTelephoneFormatted, setDrTelephoneFormatted] = useState("");
    const [drMobileStored, setDrMobileStored] = useState("");
    const [drMobileDefaultCode, setDrMobileDefaultCode] = useState(undefined);
    const [drMobileFormatted, setDrMobileFormatted] = useState("");

    // validation error values
    // emergency info
    const [relationshipError, setRelationshipError] = useState("");
    const [nameError, setNameError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [emergencyTelephoneError, setEmergencyTelephoneError] = useState("");
    const [emergencyMobileError, setEmergencyMobileError] = useState("");
    // doctor info
    const [drNameError, setDrNameError] = useState("");
    const [drAddressError, setDrAddressError] = useState("");
    const [drTelephoneError, setDrTelephoneError] = useState("");
    const [drMobileError, setDrMobileError] = useState("");

    const [refreshing, setRefreshing] = useState(false);

    // Get username from Auth Context 
    const { username, user } = useAuthContext();


    // TODO: validate emergency info
    const validateName = () => {
        if (nameRef.current !== "" && /[0-9]/.test(nameRef.current)) {
            setNameError(t('common:errName'));
            return false;
        } else {
            setNameError("");
            return true;
        };
    };

    const validateEmergencyTelephone = () => {
        // if (!emergencyTelephoneStoredRef.current) {
        //     setEmergencyTelephoneError(t('common:errRequired'));
        //     return false;
        if (emergencyTelephoneInputRef.current?.getNumberAfterPossiblyEliminatingZero().number != "") {
            if (emergencyTelephoneInputRef.current?.isValidNumber(emergencyTelephoneInputRef.current?.getNumberAfterPossiblyEliminatingZero().formattedNumber)) {
                setEmergencyTelephoneError("");
                return true;
            } else {
                setEmergencyTelephoneError(t('common:errMobile'));
                return false;
            };
        } else {
            setEmergencyTelephoneError("");
            return true;
        };
    };

    const validateEmergencyMobile = () => {
        // if (!emergencyMobileStoredRef.current) {
        //     setEmergencyMobileError(t('common:errRequired'));
        //     return false;
        if (emergencyMobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().number != "") {
            if (emergencyMobileInputRef.current?.isValidNumber(emergencyMobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().formattedNumber)) {
                setEmergencyMobileError("");
                return true;
            } else {
                setEmergencyMobileError(t('common:errMobile'));
                return false;
            };
        } else {
            setEmergencyMobileError("");
            return true;
        };
    };
    // TODO: validate doctor info
    const validateDrName = () => {
        if (drNameRef.current !== "" && /[0-9]/.test(drNameRef.current)) {
            setDrNameError(t('common:errName'));
            return false;
        } else {
            setDrNameError("");
            return true;
        };
    };

    const validateDrTelephone = () => {
        // if (!drTelephoneStoredRef.current) {
        //     setDrTelephoneError(t('common:errRequired'));
        //     return false;
        if (drTelephoneInputRef.current?.getNumberAfterPossiblyEliminatingZero().number != "") {
            if (drTelephoneInputRef.current?.isValidNumber(drTelephoneInputRef.current?.getNumberAfterPossiblyEliminatingZero().formattedNumber)) {
                setDrTelephoneError("");
                return true;
            } else {
                setDrTelephoneError(t('common:errMobile'));
                return false;
            };
        } else {
            setDrTelephoneError("");
            return true;
        };
    };

    const validateDrMobile = () => {
        // if (!drMobileStoredRef.current) {
        //     setDrMobileError(t('common:errRequired'));
        //     return false;
        if (drMobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().number != "") {
            if (drMobileInputRef.current?.isValidNumber(drMobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().formattedNumber)) {
                setDrMobileError("");
                return true;
            } else {
                setDrMobileError(t('common:errMobile'));
                return false;
            };
        } else {
            setDrMobileError("");
            return true;
        };
    };

    const validateFields = () => {
        if (!validateName() | !validateEmergencyTelephone() | !validateEmergencyMobile() | !validateDrName() | !validateDrTelephone() | !validateDrMobile()) {
            return false;
        }
        return true;
    };

    const clearValues = () => {
        setSubmitClicked(false);
        setRefreshing(false);
        // values
        setRelationship(null);
        setName(0);
        setAddress("");
        setEmergencyTelephoneStored("");
        setEmergencyTelephoneDefaultCode(undefined);
        setEmergencyTelephoneFormatted("");
        setEmergencyMobileStored("");
        setEmergencyMobileDefaultCode(undefined);
        setEmergencyMobileFormatted("");
        setDrTelephoneStored("");
        setDrTelephoneDefaultCode(undefined);
        setDrTelephoneFormatted("");
        setDrMobileStored("");
        setDrMobileDefaultCode(undefined);
        setDrMobileFormatted("");
        // validation error values
        setRelationshipError();
        setNameError();
        setAddressError();
        setEmergencyTelephoneError();
        setEmergencyMobileError();
        setDrNameError();
        setDrAddressError();
        setDrTelephoneError();
        setDrMobileError();
    };

    const onAccountSave = async (e) => {
        e.preventDefault();

        setSubmitClicked(true);

        if (!validateFields()) {
            showMessage({
                message: t('common:errAllFields'),
                type: "danger",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
        } else {
            // TODO
            // setIsLoading(true);

            const emergencyInformationData = {
                username: username,
                nokRel: relationshipRef.current,
                nextOfKin: nameRef.current,
                nokAddress: addressRef.current,
                nokTel: emergencyTelephoneInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? emergencyTelephoneInputRef.current.getNumberAfterPossiblyEliminatingZero().formattedNumber : null,
                nokTelMob: emergencyMobileInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? emergencyMobileInputRef.current.getNumberAfterPossiblyEliminatingZero().formattedNumber : null,
                drName: drNameRef.current,
                drAddress: drAddressRef.current,
                drTel: drTelephoneInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? drTelephoneInputRef.current.getNumberAfterPossiblyEliminatingZero().formattedNumber : null,
                drTelMob: drMobileInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? drMobileInputRef.current.getNumberAfterPossiblyEliminatingZero().formattedNumber : null,
            }
            console.log(account.nokRel);
            console.log("-----------------")
            console.log(emergencyInformationData)
            console.log("-----------------")

            await emergencyInformationEdit(emergencyInformationData);
            setSubmitClicked(false);
        };
    };

    // useEffect(() => {ƒ
    //     navigation.setOptions({
    //         headerRight: () => (
    //             <CustomButton
    //                 text={t('common:save')}
    //                 disabled={!user.editPersonalData}
    //                 onPress={onAccountSave}
    //                 type="TOPRIGHT"
    //             />
    //         ),
    //     });
    // }, [navigation]);

    /* needed to avoid memory leaks/warnings
       when navigating through different pages */
    useEffect(() => {
        return () => {
            clearValues();
        };
    }, []);

    // Used for Refresh
    const onEmergencyInformationGet = async () => {
        await emergencyInformationGet();
    };

    // set initial info from database
    useEffect(() => {
        // emergency info
        setRelationship(account.nokRel);
        setName(account.nextOfKin);
        setAddress(account.nokAddress);

        // emergency telephone
        var parsedEmergencyTelephone = null;
        // try to parse whole telephone phone number (including country code)
        try {
            if (account.nokTel != '') {
                parsedEmergencyTelephone = phoneUtil.parse(account.nokTel, '')
            }
        } catch (e) {
            console.log(e);
        };
        // extract number using library
        try {
            if (parsedEmergencyTelephone != null) {
                setEmergencyTelephoneStored(parsedEmergencyTelephone.getNationalNumber(), '');
            }
        } catch (e) {
            console.log(e);
            setEmergencyTelephoneStored(account.nokTel);
        };
        // set default country code based on parsed number
        try {
            const defaultCode = phoneUtil.getRegionCodeForNumber(parsedEmergencyTelephone);
            setEmergencyTelephoneDefaultCode(!defaultCode ? "CY" : defaultCode);
        } catch (e) {
            console.log(e);
            setEmergencyTelephoneDefaultCode("CY");
        };

        // emergency mobile
        var parsedEmergencyMobile = null;
        // try to parse whole mobile phone number (including country code)
        try {
            if (account.nokTelMob != '') {
                parsedEmergencyMobile = phoneUtil.parse(account.nokTelMob, '')
            }
        } catch (e) {
            console.log(e);
        };
        // extract number using library
        try {
            if (parsedEmergencyMobile != null) {
                setEmergencyMobileStored(parsedEmergencyMobile.getNationalNumber(), '');
            }
        } catch (e) {
            console.log(e);
            setEmergencyMobileStored(account.nokTelMob);
        };
        // set default country code based on parsed number
        try {
            const defaultCode = phoneUtil.getRegionCodeForNumber(parsedEmergencyMobile);
            setEmergencyMobileDefaultCode(!defaultCode ? "CY" : defaultCode);
        } catch (e) {
            console.log(e);
            setEmergencyMobileDefaultCode("CY");
        };

        // doctor info
        setDrName(account.drName);
        setDrAddress(account.drAddress);

        // doctor telephone
        var parsedDrTelephone = null;
        // try to parse whole telephone phone number (including country code)
        try {
            if (account.drTel != '') {
                parsedDrTelephone = phoneUtil.parse(account.drTel, '')
            }
        } catch (e) {
            console.log(e);
        };
        // extract number using library
        try {
            if (parsedDrTelephone != null) {
                setDrTelephoneStored(parsedDrTelephone.getNationalNumber(), '');
            }
        } catch (e) {
            console.log(e);
            setDrTelephoneStored(account.drTel);
        };
        // set default country code based on parsed number
        try {
            const defaultCode = phoneUtil.getRegionCodeForNumber(parsedDrTelephone);
            setDrTelephoneDefaultCode(!defaultCode ? "CY" : defaultCode);
        } catch (e) {
            console.log(e);
            setDrTelephoneDefaultCode("CY");
        };

        // doctor mobile
        var parsedDrMobile = null;
        // try to parse whole mobile phone number (including country code)
        try {
            if (account.drTelMob != '') {
                parsedDrMobile = phoneUtil.parse(account.drTelMob, '')
            }
        } catch (e) {
            console.log(e);
        };
        // extract number using library
        try {
            if (parsedDrMobile != null) {
                setDrMobileStored(parsedDrMobile.getNationalNumber(), '');
            }
        } catch (e) {
            console.log(e);
            setDrMobileStored(account.drTelMob);
        };
        // set default country code based on parsed number
        try {
            const defaultCode = phoneUtil.getRegionCodeForNumber(parsedDrMobile);
            setDrMobileDefaultCode(!defaultCode ? "CY" : defaultCode);
        } catch (e) {
            console.log(e);
            setDrMobileDefaultCode("CY");
        };
    }, []);

    useEffect(() => {
        submitClickedRef.current = submitClicked;
    }, [submitClicked]);

    useEffect(() => {
        relationshipRef.current = relationship;
    }, [relationship]);

    useEffect(() => {
        nameRef.current = name;
        if (submitClickedRef.current) {
            validateName();
        };
    }, [name]);

    useEffect(() => {
        addressRef.current = address;
    }, [address]);

    useEffect(() => {
        emergencyMobileStoredRef.current = emergencyMobileStored;
    }, [emergencyMobileStored]);

    useEffect(() => {
        if (submitClickedRef.current) {
            validateEmergencyMobile();
        };
    }, [emergencyMobileFormatted]);

    useEffect(() => {
        emergencyTelephoneStoredRef.current = emergencyTelephoneStored;
    }, [emergencyTelephoneStored]);

    useEffect(() => {
        if (submitClickedRef.current) {
            validateEmergencyTelephone();
        };
    }, [emergencyTelephoneFormatted]);

    useEffect(() => {
        drNameRef.current = drName;
        if (submitClickedRef.current) {
            validateDrName();
        };
    }, [drName]);

    useEffect(() => {
        drAddressRef.current = drAddress;
    }, [drAddress]);

    useEffect(() => {
        drMobileStoredRef.current = drMobileStored;
    }, [drMobileStored]);

    useEffect(() => {
        if (submitClickedRef.current) {
            validateDrMobile();
        };
    }, [drMobileFormatted]);

    useEffect(() => {
        drTelephoneStoredRef.current = drTelephoneStored;
    }, [drTelephoneStored]);

    useEffect(() => {
        if (submitClickedRef.current) {
            validateDrTelephone();
        };
    }, [drTelephoneFormatted]);

    // Pull Down to Refresh callback
    const onRefresh = useCallback(() => {
        setRefreshing(true);
        // Call Async Function
        onEmergencyInformationGet()
            // make sure to catch any error
            .catch(console.error);
        setRefreshing(false);
    }, []);

    return (
        <KeyboardAwareContainer 
            style={{ flex: 1 }}
            contentContainerStyle={{
                flexGrow: 1,
                paddingBottom: Math.max(insets.bottom + 24, 40),
            }}
            enableOnAndroid
            enableAutomaticScroll
            keyboardShouldPersistTaps="handled"
            extraScrollHeight={Platform.OS !== 'web' ? 220 : 200}
            showsVerticalScrollIndicator={false}
            refreshControl={
                <RefreshControl
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                />
            }
        >
            <View style={styles.mainView} >
                <CustomLabel
                    value={t('common:fullName')}
                    type='MYPROFILE'
                />
                <CustomInput
                    value={name}
                    editable={user.editPersonalData}
                    setValue={setName}
                    type='MYPROFILE'
                    placeholder={`${t('common:fullName')}...`}
                />
                <CustomText style={styles.error}>{nameError}</CustomText>
                <View style={[styles.row, { zIndex: 1 }]}>
                    <View style={styles.inputContainer}>
                        <CustomLabel
                            value={t('common:relationship')}
                            type='MYPROFILE'
                        />
                        <CustomDropDownWithIcons
                            defValue={relationship}
                            disabled={!user.editPersonalData}
                            options={relationshipOptions}
                            value={relationship}
                            setValue={setRelationship}
                            type='MYPROFILE'
                        />
                        <CustomText style={styles.error}>{relationshipError}</CustomText>
                    </View>
                </View>
                <CustomLabel
                    value={t('common:address')}
                    type='MYPROFILE'
                />
                <CustomInput
                    value={address}
                    setValue={setAddress}
                    editable={user.editPersonalData}
                    type='MYPROFILE'
                    placeholder={`${t('common:address')}...`}
                />
                <CustomText style={styles.error}>{addressError}</CustomText>

                <CustomLabel
                    value={t('common:telephone')}
                    type='MYPROFILE'
                />
                {emergencyTelephoneDefaultCode !== undefined &&
                    <CustomPhoneNumber
                        ref={emergencyTelephoneInputRef}
                        editable={user.editPersonalData}
                        defaultValue={"" + emergencyTelephoneStored}
                        defaultCode={emergencyTelephoneDefaultCode}
                        onChangeText={setEmergencyTelephoneStored}
                        onChangeFormattedText={(number) => {
                            setEmergencyTelephoneFormatted(number);
                        }}
                        type='MYPROFILE'
                    />
                }
                <CustomText style={styles.error}>{emergencyTelephoneError}</CustomText>

                <CustomLabel
                    value={t('common:mobile')}
                    type='MYPROFILE'
                />
                {emergencyMobileDefaultCode !== undefined &&
                    <CustomPhoneNumber
                        ref={emergencyMobileInputRef}
                        editable={user.editPersonalData}
                        defaultValue={"" + emergencyMobileStored}
                        defaultCode={emergencyMobileDefaultCode}
                        onChangeText={setEmergencyMobileStored}
                        onChangeFormattedText={(number) => {
                            setEmergencyMobileFormatted(number);
                        }}
                        type='MYPROFILE'
                    />
                }
                <CustomText style={styles.error}>{emergencyMobileError}</CustomText>

                {/* Save Button */}
                <CustomButton
                    text={t('common:save')}
                    onPress={onAccountSave}
                    disabled={!user.editPersonalData || submitClicked}
                    isGradient={true}
                    type={(!user.editPersonalData || submitClicked) ? 'SAVE_WEB_DISABLED' : 'BUTTON_SAVE' }
                />
            </View>
        </KeyboardAwareContainer>
    );
};

const makeStyles = (colors, colorScheme) => StyleSheet.create({

    mainView: {
        flex: 1,
        justifyContent: 'center',
        marginHorizontal: 15,
        // alignItems: 'center',
    },
    scroll: {
        flex: 1,
        width: (Platform.OS === 'web' && width > 992) ? width / 2 : '100%'
    },
    margin: {
        marginHorizontal: 10,
        marginVertical: 5
    },
    input: {
        backgroundColor: colors.background_dropdown,
        color: colors.text_input,
        height: 20
    },
    button: {
        color: colors.buttons,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14
    },
});

export default MyAccountEmergencyInformationScreen;